import { useEffect } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { cx } from '@linaria/core';
import { useUserMe } from '~/api-client/food_api/user';
import { useApplicationMode } from '~/provider/ApplicationProvider';
import { useUnreadBadge } from '~/provider/UnreadBadgeProvider';
import { UnreadBadge } from '../data-display/UnreadBadge';
import { Addition01Icon, MessageIcon, MypageIcon, ReplyIcon, SearchIcon } from '../icons';
const footerHeightStyle = "fu9i7p8";
export const Footer: React.FC<{}> = props => {
  const me = useUserMe();
  const router = useRouter();
  const unreadBadge = useUnreadBadge();
  const applicationMode = useApplicationMode();
  useEffect(() => {
    const root = document.querySelector(':root');
    if (root != null) {
      ;
      (root as HTMLElement).style.setProperty('--footer-height', applicationMode === 'inapp' ? '0px' : '54px');
    }
  }, [applicationMode]);
  return <>
      <div className={cx(footerHeightStyle)} />
      <div className={cx(footerHeightStyle, 'bg-function fixed bottom-0 left-0 w-full z-50')}>
        <div className={cx('max-w-screen-md mx-auto w-full grid grid-cols-5 h-full')}>
          <Link className="flex items-center justify-center relative" href="/search/foodies">
            <SearchIcon fill={router.asPath.startsWith('/search') ? 'var(--color-primary)' : '#fff'} />
          </Link>
          <Link className="flex items-center justify-center relative" href="/chat_spaces">
            <MessageIcon fill={router.asPath.startsWith('/chat_spaces') ? 'var(--color-primary)' : '#fff'} />
            <div className="absolute top-2 right-4">
              <UnreadBadge count={unreadBadge.response?.unreadBadgeList.chatTotal} />
            </div>
          </Link>
          <Link className="flex items-center justify-center relative" href="/dinners">
            <Addition01Icon fill={router.asPath.startsWith('/dinners') ? 'var(--color-primary)' : '#fff'} />
          </Link>
          <Link className="flex items-center justify-center" href="/tweets">
            <ReplyIcon fill={router.asPath.startsWith('/tweets') ? 'var(--color-primary)' : '#fff'} />
          </Link>
          <Link className="flex items-center justify-center relative" href={me.data ? `/foodies/${me.data.user.userName}` : ''}>
            <MypageIcon fill={router.asPath.startsWith('/account') || router.asPath.startsWith(`/foodies/${me.data?.user.userName}`) ? 'var(--color-primary)' : '#fff'} />
            <div className="absolute top-2 right-4">
              <UnreadBadge count={unreadBadge.response?.unreadBadgeList.mypageTotal} />
            </div>
          </Link>
        </div>
      </div>
    </>;
};

require("./Footer.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Footer.tsx");